import { render } from "./SeTaxYear.vue?vue&type=template&id=463350b2"
import script from "./SeTaxYear.vue?vue&type=script&lang=js"
export * from "./SeTaxYear.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__